import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

const CancelIndentButton = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};

  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClick = (type, e) => {
    e.stopPropagation();
    switch (type) {
      case "cancelindent":
        context.cancelindent(indent);
        break;
      default:
        break;
    }
  };

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY, // position above
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
    <div style={{ display: "flex", gap: "5px", position: "relative" }}>
      {indent.is_draft === 1 ? null : (
        <div style={{ position: "relative" }}>
          <button
            onClick={(e) => handleClick("cancelindent", e)}
            className="custom-btn label label-success"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            disabled={indent.truck_details_completed === 1}
            style={{
              opacity: indent.truck_details_completed === 1 ? 0.6 : 1,
              cursor:
                indent.truck_details_completed === 1
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            <img
              src={require("../../assets/images/forbidden.svg")}
              style={{ pointerEvents: "none", marginTop: "-4px" }}
              alt="Cancel"
            />
          </button>
          {showPopover && (
            <PopoverContent
              content="Reject Indent"
              position={position}
              onClose={() => setShowPopover(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CancelIndentButton;
